import { IQuestionModel } from '@care-portals/api-interfaces';

type _ORG = {
  organization: string;
  label: string;
  pc_name: string;
  address?: string;
};

const orgs: _ORG[] = [
  {
    organization: 'momwell_cali',
    label: 'Momwell Cali',
    pc_name: 'Momwell Medical Group of California, P C.',
    address: '6469 Almaden Expressway Ste 80 #750 San Jose, CA 95120'
  },
  {
    organization: 'momwell_ny',
    label: 'Momwell NY',
    pc_name: '9560 Medical, P.C.',
    address: '228 Park Ave S. #87963 New York, New York 10003-1502'
  },
  {
    organization: 'momwell_super',
    label: 'Momwell Super',
    pc_name: 'MOMWELL MEDICAL GROUP, PA',
    address: '6421 N Florida Ave. D-395 Tampa, FL 33604'
  },
  {
    organization: 'momwell',
    label: 'Momwell Arch',
    pc_name: 'Momwell'
  },
  {
    organization: 'happyasamother_co',
    label: 'Momwell Canada',
    pc_name: ' Momwell lnc.'
  }
];

const questionsModels: IQuestionModel[] = [
  {
    label: 'Consent to Disclose Information for Coordination of Care',
    field: 'consentToDisclose_info',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Date of Birth',
          type: 'date',
          placeholder: 'Please enter your date of birth',
          name: 'consentToDisclose_dateOfBirth',
          required: true
        },
        {
          label: 'Provider/Provider Group Name',
          type: 'text',
          placeholder: '',
          required: true,
          name: 'consentToDisclose_providerName'
        },
        {
          label: 'Disclose the following information for coordination of care:',
          type: 'single_select',
          level: 'child',
          options: [
            {
              key: 'consentToDisclose_administrativeInformation',
              value:
                'Administrative Information; appointment times, insurance billing information'
            },
            {
              key: 'consentToDisclose_diagnosis',
              value: 'Diagnosis'
            },
            {
              key: 'consentToDisclose_treatmentPlans',
              value: 'Treatment plans'
            },
            {
              key: 'consentToDisclose_treatmentProgress',
              value: 'Treatment progress'
            },
            {
              key: 'consentToDisclose_medicationLists',
              value: 'Medication lists'
            },
            {
              key: 'consentToDisclose_medicalReport',
              value: 'Medical Report'
            },
            {
              key: 'consentToDisclose_allOfTheAbove',
              value: 'All of the above'
            }
          ]
        }
      ]
    }
  },
  {
    label: 'Consent to Disclose Information for Coordination of Care',
    educationalSlide: `
    <P>For the purposes of coordination and continuity of care, I authorize {{PC_NAME}} - {{PC_ADDRESS}} to the person or organization noted above.</P>
    <P>I understand the purpose for disclosing this information to the person or organization noted above. I understand that I can refuse to sign this consent.</P>
    <P>I understand that this information will only be used for the purpose of ensuring continuity of care and that any disclosure of this information will be done in accordance with applicable privacy laws and regulations. I also understand that the provider who receives this information will be bound by the same ethical and legal requirements regarding confidentiality and privacy as all my medical and behavioral care providers.</P>
    <P>I understand that I have the right to revoke this consent at any time by providing written notice to my therapist.</P>
    <P>By signing this consent form, I acknowledge that I have read and understand the information provided and have had an opportunity to ask any questions about the disclosure of my information. I freely and voluntarily consent to the disclosure of this information for the purposes outlined above.</P>
    `,
    field: 'consentToDisclose_consent',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'My Name (first and last name)',
          type: 'text',
          placeholder: '',
          required: true,
          name: 'consentToDisclose_name'
        },
        {
          label: 'Signing Date',
          type: 'date',
          required: true,
          name: 'consentToDisclose_signingDate'
        },
        {
          label: 'Signature',
          type: 'esign',
          required: true,
          name: 'consentToDisclose_signature'
        },
        {
          label: 'Witness Signature',
          type: 'witness-esign',
          required: true,
          name: 'consentToDisclose_witnessSignature',
          witness: {
            name: 'Heather Alexander',
            sig: 'HeatherAlexander.png',
            date: '$now'
          }
        }
      ]
    }
  }
];

const getEducationalSlide = (org: _ORG, q: IQuestionModel) => {
  let educationalSlide = q.educationalSlide;

  if (!educationalSlide) {
    return educationalSlide;
  }

  const renderedEducationalSlide = educationalSlide
    .replace(/{{PC_NAME}}/g, org.pc_name || '')
    .replace(/{{PC_ADDRESS}}/g, org.address || '');

  return renderedEducationalSlide;
};

const consentToDiscloseQuestions = orgs
  .map(o =>
    questionsModels.map(q => ({
      ...q,
      educationalSlide: getEducationalSlide(o, q),
      field: o.organization + '_' + q.field
    }))
  )
  .flat();

export default consentToDiscloseQuestions;
